export const ORDER_TRACKER_CONFIG = {
  READY_HIDE_TTL_MIN: 15,
  MINUTES_IN_MS: 60 * 1000,

  POLLING: {
    INTERVAL: 15 * 60 * 1000,
  },

  UX: {
    MIN_REFRESH_DURATION: 2000,
    RETRY_DELAY_BASE: 1000,
    ASAP_WINDOW_MIN: 15,
  },

  TIMERS: {
    TTL_PRUNE_INTERVAL_MS: 5 * 60 * 1000,
    MIDNIGHT_REFRESH_DELAY_MS: 5 * 60 * 1000,
  },

  API: {
    MAX_HISTORY_ITEMS: 50,
    MAX_RETRIES: 3,
  },

  CACHE: {
    DETAIL_TTL_MS: 30_000,
  },

  FLATLIST: {
    INITIAL_NUM_TO_RENDER: 3,
    MAX_TO_RENDER_PER_BATCH: 5,
    WINDOW_SIZE: 10,
  },
} as const;
